import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { Icon, Tooltip, RawHtml, ButtonIcon, ChipOutlined } from 'platfi-ui-components';

import { borrowCostFields, filterOptions } from 'enums/offer-details-fields';
import { ProductTypeDataName, ProductTypeLabel } from 'enums/product-type';
import { FundingMatchReportStatusLabel } from 'enums/funding-match-status';
import { MatchDocumentType, MatchDocumentTooltip } from 'enums/match-document-type';

import { bemClassName } from 'utils/BEMHelper';

import FundingMatchModel from 'models/FundingMatchModel';

import TagLabel from 'components/MonitorClientOld/InsightCards/TagLabel/TagLabel';
import FundingMatchCardRow from 'modules/MatchesNav/components/FundingMatchCardRow/FundingMatchCardRow';

import styles from './ShareableReportCard.scss';

const ShareableReportCard = ({ match, draggable, setMappedMatches }) => {
  const getOfferName = () => {
    const { canUseInstantOffer, canUseInstantApplication } = match;
    const { offer, application } = MatchDocumentType;
    const instantOfferName = canUseInstantOffer && offer;
    const instantApplicationName = canUseInstantApplication && application;

    return instantOfferName || instantApplicationName;
  };

  const { offer, status, lender, isHidden } = match;

  const { logo, logoUrl, companyName, hasInstantOffer, hasInstantApplication } = lender;

  const styleName = bemClassName('m-shareable-response-card', { draggable, hidden: isHidden });
  const toggleStyleName = bemClassName('m-shareable-response-card__hide-toggle', {
    hidden: isHidden,
  });

  const productData = offer[ProductTypeDataName[offer.productType]] || {};
  const productName = ProductTypeLabel[offer.productType] || 'No Product';
  const isSupportInstantDocument = hasInstantOffer || hasInstantApplication;
  const borrowCostData = filterOptions(productData, borrowCostFields, 'Not Specified');
  const offerName = getOfferName();

  return (
    <div styleName={styleName}>
      <div styleName="m-shareable-response-card__header">
        <Icon icon="drag_wide" className="a-svg a-svg-medium" />
        <ButtonIcon
          onClick={() => setMappedMatches(match.id, 'isHidden', !isHidden)}
          icon={isHidden ? 'eye' : 'eye_private'}
          label={isHidden ? 'Show Response' : 'Hide Response'}
          iconRight
          small
          styleName={toggleStyleName}
        />
      </div>
      <div styleName="m-shareable-response-card__content">
        <div className="u-flex-align-center" styleName="m-shareable-response-card__image-wrapper">
          <img
            alt={companyName}
            src={logo || logoUrl}
            styleName="m-shareable-response-card__image"
          />
        </div>
        <TagLabel
          styleName="m-shareable-response-card__content__tag"
          light
          uppercase
          label={productName}
        />
        <ChipOutlined
          small
          primary
          uppercase
          styleName="m-shareable-response-card__chip"
          label={FundingMatchReportStatusLabel[status]}
        />
      </div>
      <div styleName="m-shareable-response-card__footer">
        {isSupportInstantDocument && (
          <div styleName="m-shareable-response-card__offer-icon">
            <Tooltip
              bottom
              smallWidth
              tooltipContent={<RawHtml>{MatchDocumentTooltip[offerName]}</RawHtml>}
            >
              <Icon icon={offerName} className="a-svg-large u-inline-block" />
            </Tooltip>
          </div>
        )}
        <div styleName="m-shareable-response-card__row">
          {borrowCostData?.optionValue ? (
            <FundingMatchCardRow
              isTooltipHidden
              config={borrowCostData.config}
              value={borrowCostData.optionValue}
            />
          ) : (
            '-'
          )}
        </div>
      </div>
    </div>
  );
};

ShareableReportCard.propTypes = {
  draggable: PropTypes.bool,
  setMappedMatches: PropTypes.func,
  match: PropTypes.instanceOf(FundingMatchModel).isRequired,
};

export default CSSModules(ShareableReportCard, styles, { allowMultiple: true });
